import { render, staticRenderFns } from "./EditBoxSelect.vue?vue&type=template&id=2a16e56c&scoped=true&"
import script from "./EditBoxSelect.vue?vue&type=script&lang=js&"
export * from "./EditBoxSelect.vue?vue&type=script&lang=js&"
import style0 from "../../../src/assets/css/shop-console.css?vue&type=style&index=0&id=2a16e56c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a16e56c",
  null
  
)

export default component.exports